import { Modal } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { useState } from "react";

import { Col, Grid, Row, SpicyButton, SpicyInput, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

type UpdateCloneTitleModalProps = {
  isVisible: boolean;
  conversationLabel: string;
  characterName: string;
  setIsUpdateCloneTitleModal: (show: boolean) => void;
  handleCloneTitleUpdate: (title: string) => void;
};

const UpdateCloneTitleModal = ({
  isVisible,
  setIsUpdateCloneTitleModal,
  handleCloneTitleUpdate,
  conversationLabel,
  characterName,
}: UpdateCloneTitleModalProps) => {
  const { t } = useTranslation();
  const [cloneTitle, setCloneTitle] = useState(conversationLabel || characterName);

  const handleClose = () => {
    setIsUpdateCloneTitleModal(false);
  };

  const handleUpdate = () => {
    handleCloneTitleUpdate(cloneTitle);
    handleClose();
  };

  return (
    <Modal
      title={t("chat:modal.updateConversationTitle.title")}
      classNames={{ title: "text-center pl-[28px]" }}
      open={isVisible}
      backdrop="blur"
      onOpenChange={handleClose}
    >
      <Col align="center">
        <Grid className="w-[260px] mt-2">
          <SpicyInput
            variant="secondary_bordered"
            color="transparent"
            placeholder={t("chat:modal.updateConversationTitle.input.placeholder")}
            value={cloneTitle}
            onValueChange={setCloneTitle}
            maxLength={50}
          />
        </Grid>
      </Col>

      <Row justify="center" className="*:w-[150px]" gap={1}>
        <SpicyButton variant="bordered" onPress={handleClose}>
          <Text type={"medium"}>
            <Trans i18nKey="common:cancel" />
          </Text>
        </SpicyButton>
        <SpicyButton color="primary_strong" onPress={handleUpdate} isDisabled={!cloneTitle}>
          <Text type={"medium white"}>
            <Trans i18nKey="common:update" />
          </Text>
        </SpicyButton>
      </Row>
    </Modal>
  );
};

export default UpdateCloneTitleModal;
